import {
    CommentsModel,
    ContextModel,
    DocumentsAssetsApiResponse,
    DocumentsModel,
    GetThreadsOutputModel,
    IndexModel,
    Result,
    AlarmsModel,
} from "../api/APIClient";
import { ProjectQuery, RightPanelSignalsModel, UserQuery } from "./SignalModels";

export interface ResponseOfFullAssetInformationModel extends Result {
    data: FullAssetInformation;
}

export interface ResponseInfoPanel extends Result {
    data: InfoModel | null;
}
export interface ResponseISOPanel extends Result {
    data: InfoModel | null;
}
export interface ResponseCommentsPanel extends Result {
    data: CommentsModel | null;
}
export interface ResponseThreadPanel extends Result {
    data: ThreadModel | null;
}

export interface ResponseSignalsPanel extends Result {
    data: RightPanelSignalsModel | null;
}

export interface ResponseAlarmPanel extends Result {
    data: AlarmsModel | null;
}

export interface FullAssetInformation {
    rightPanels?: RightPanelsModel | null;
    index?: IndexModel | null;
    render?: RenderModel[] | null;
}

export interface TooltipModel {
    type?: string | null;
    content?: string | null;
    data?: { [key: string]: string } | null;
}

export interface StyleModel {
    hexColor?: string | null;
}

export enum RenderModelType {
    Selected = 1,
    Parent,
    Children,
    Noozle,
}

export interface RenderModel {
    dbIds?: number[] | null;
    tooltip?: TooltipModel | null;
    style?: StyleModel | null;
    type?: RenderModelType | null;
    legend?: string | null;
    coords?: { x: number; y: number; z: number };
}

export interface FetchAssetInformationByIdQuery {
    projectId: string;
    id: string;
    userId: string;
}

export interface FetchAssetInformationByDbIdQuery extends ProjectQuery {
    input: {
        projectId: string;
        dbId: number;
        userId: string;
    };
}

export interface InfoModel {
    icon?: string | null;
    title?: string | null;
    description?: string | null;
    data: { [key: string]: InfoDataModel[] } | null;
}

export interface InfoDataModel {
    key?: string | null;
    value?: string | null;
    order?: number | null;
}

export interface TimeLine {
    date: string;
    name: string;
    descrip: string | null;
    color: string;
}

export interface TimeLineDataModel {
    icon: string;
    title: string;
    description: string;
    data: TimeLine[];
}

export interface ConfirmationData {
    // TO DO define it
    todo: string;
}
export interface ConfirmationModel {
    data: { [key: string]: string | null }[] | [];
    description: string;
    icon: string;
    title: string;
}

export interface DocumentsRightPanelModel {
    icon?: string | null;
    title?: string | null;
    description?: string | null;
    data?: DocumentsAssetsApiResponse | null;
}

export interface RightPanelsModel {
    info?: InfoModel | null;
    confirmations?: ConfirmationModel | null;
    signals?: RightPanelSignalsModel | null;
    documents?: DocumentsRightPanelModel | null;
    chat?: ThreadModel | null;
    context?: ContextModel | null;
    alarms?: AlarmsModel | null;
    isometrics?: GetIsoPanelOutput | null;
    timeLine?: TimeLineDataModel | null;
}

export interface ThreadModel {
    icon?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    data?: GetThreadsOutputModel | undefined;
}

export interface GetCountEquiposOutput {
    count: number;
}

export interface ResultGetCountEquiposOutput extends Result {
    data: GetCountEquiposOutput;
}

export interface IsoPanelItemModel {
    id?: string | undefined;
    tag?: string | undefined;
    description?: string | undefined;
    dbIds?: number[] | undefined;
    onModel?: boolean;
}

export interface GetIsoPanelOutput {
    icon: string;
    title: string;
    description: string;
    data: IsoPanelItemModel[];
}

export interface ResultGetIsoPanelOutput extends Result {
    data: GetIsoPanelOutput;
}

